import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { storageApiDto } from 'src/app/interfaces/Dtos/storage-api.dto';
import { ISites } from 'src/app/interfaces/ISites';
import { IUiviews } from 'src/app/interfaces/IUiviews';
import { ILoginResponse } from 'src/app/interfaces/Responses/ILoginResponse';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { ClarityServiceService } from 'src/app/services/shared/clarity-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'neoris-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit, OnChanges {

  public location: string = "";

  @Input() loginResponse: ILoginResponse

  all: string = 'ALL'
  sites: ISites[] = []
  langs: string[] = []
  userInitials: string = ''
  fullName: string
  menues: any[]
  currentYear: string
  isExpanded = false
  currentResponseUpd: any
  canViewRealtimeDashboard: boolean = false
  canViewGeneralDashboard: boolean = false
  canViewFastTrackDashboard: boolean = false
  canViewPlantEfficiencyDashboard: boolean = false
  canViewTruckEfficiencyDashboard: boolean = false
  canViewTotalCountryDashboard: boolean = false
  isIndustrial: boolean = false
  siteName: string
  siteId: string

  constructor(
    private authService: MsalService,
    private translate: TranslateService,
    private router: Router,
    private controlTowerService: ControltowerService,
    private clarity: ClarityServiceService,
    private propertiesService: PropertiesTowers, private cookieService: CookieService) {
    let today = new Date()
    this.currentYear = today.getFullYear().toString()
    this.langs = this.translate.getLangs()
  }

  ngOnChanges(changes: SimpleChanges): void {

    console.log("changes", changes)




    const currentResponse = changes.loginResponse.currentValue
    this.currentResponseUpd = currentResponse

    console.log("currentResponse?.sites", currentResponse?.sites)

    if (currentResponse !== undefined) {

      //Disable Clarity tracking 
     



      if (this.isIndustrial) {
        const foundIndustrial = currentResponse?.sites.find((obj) => {
          return obj.name === this.siteName;
        });
        this.sites.push(foundIndustrial);
      } else {
        this.sites = currentResponse?.sites
      }

      const siteSelected = localStorage.getItem('site');
      if (siteSelected == null) {
        localStorage.setItem('site', this.sites[0].id.toString())
      }

      this.siteId = localStorage.getItem('site');

      
      // this.ConfigureBlobStorageUrlApi(this.siteId.split(','))
      // this.getStorageApiBySite();

      this.menues = currentResponse?.uiviews
      this.fullName = JSON.parse(localStorage.getItem('ud'))[0]?.value
      this.userInitials = this.setAvatar(this.fullName)
      
      this.InitClarity(this.siteId, this.fullName);


      
      var MLang = 'en'



      for (let i = 0; i < currentResponse.uiviews.length; i++) {
        if (MLang === "en") {
          currentResponse.uiviews[i].name = currentResponse.uiviews[i].namE_EN;
        }
        else {
          currentResponse.uiviews[i].name = currentResponse.uiviews[i].namE_ES;
        }
      }
      this.setViewMenu(currentResponse.uiviews)
    }
  }

  ngOnInit(): void {
    this.isIndustrial = environment.isIndustrial;
    this.siteName = environment.siteName;

    console.log("this.SiteName", this.siteName)
  }

  setViewMenu(rolesAndViews: IUiviews[]) {
    rolesAndViews.forEach(element => {
      switch (element.menU_ID) {
        case 2:
          this.canViewRealtimeDashboard = true
          break
        case 3:
          this.canViewGeneralDashboard = true
          break
        case 4:
          this.canViewFastTrackDashboard = true
          break
        case 5:
          this.canViewPlantEfficiencyDashboard = true
          break
        case 6:
          this.canViewTruckEfficiencyDashboard = true
          break
        case 7:
          this.canViewTotalCountryDashboard = true
      }
    })
  }

  setAvatar(user: string) {
    if (user !== null && user.trim() !== '') {
      let words = user.split(' ')
      if (words.length > 1) {
        return `${words[0].slice(0, 1)}${words[1].slice(0, 1)}`.toUpperCase()
      } else {
        return user.slice(0, 1).toUpperCase()
      }
    }
  }

  changeLang(lang: string) {
    this.translate.use(lang)
    this.all = this.translate.instant('ALL')

    var MTitle
    var SSMenuId

    for (let i = 0; i < this.menues.length; i++) {

      SSMenuId = this.menues[i].menU_ID
      MTitle = document.getElementById(SSMenuId);

      if (MTitle != null) {
        if (lang === "en") {
          MTitle!.innerText = this.menues[i].namE_EN;
        }
        else {
          MTitle!.innerText = this.menues[i].namE_ES;
        }
      }
    }
  }

  private InitClarity(site: string, fullName: string) {

      console.log("InitClarity", site, fullName)
      if(site.toString() == "6000"){

        console.log('Clarity tracking disabled for site:', site);
        // (window as any).clarity('set', 'tracking', false);

      }else{
    
        this.clarity.loadClarity(fullName);

      }
  }

  changeSite(site: string) {

    // this.NotReportToClarity(site);

    if (site == "0") {
      site = ''
      this.sites.forEach(element => {
        site = site + element.id + ","
      });

      site = site.slice(0, site.length - 1)

    }

    this.canViewRealtimeDashboard = false
    localStorage.setItem('site', site)
    this.siteId = site
    this.setViewMenu(this.currentResponseUpd.uiviews)
    this.propertiesService.setIsSelectedAllSites(true)

    // this.ConfigureBlobStorageUrlApi(site.split(','))
  }

  openMenu() {
    this.showMenu('header-toggle', 'navbar')
  }

  showMenu(headerToggle, navbarId) {
    const toggleBtn = document.getElementById(headerToggle),
      nav = document.getElementById(navbarId)

    if (headerToggle && navbarId) {
      toggleBtn.addEventListener('click', () => {
        nav.classList.toggle('show-menu')
        toggleBtn.classList.toggle('bx-x')
      })
    }
  }

  collapse() {
    this.isExpanded = false
  }

  toggle() {
    this.isExpanded = !this.isExpanded
  }

  logout() {
    localStorage.removeItem('ud')
    localStorage.removeItem('site')
    this.authService.logout()

    this.cookieService.delete('access-token');
  }

  showSubmenu(idElement) {
    const navtest = document.getElementById(idElement);
    if (navtest.style.maxHeight) {
      navtest.style.maxHeight = null;
    } else {
      navtest.style.maxHeight = "100rem";
    }
  }

  // private ConfigureBlobStorageUrlApi(sitesId: any){
  //   var location = localStorage.getItem('location');
  //   if(location == null){
  //     this.getNavegatorLocation(sitesId)
  //   }else{
  //     this.location = localStorage.getItem('location')      
  //     this.getStorageApiBySite(sitesId)
  //   }
  // }

  // getNavegatorLocation(sitesId: any): Promise<{ latitude: number; longitude: number }> {
  //   return new Promise((resolve, reject) => {
  //     if (!navigator.geolocation) {
  //       reject('La geolocalización no está disponible en este navegador.');
  //     }
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         this.getContinentFromCoordinates(position.coords.latitude, position.coords.longitude).then((continent) => {
  //           localStorage.setItem('location', continent)
  //           this.getStorageApiBySite(sitesId)
  //         });
  //         resolve({
  //           latitude: position.coords.latitude,
  //           longitude: position.coords.longitude,
  //         })


  //       },
  //       (error) => reject(error.message)
  //     );
  //   });
  // }

  // getContinentFromCoordinates(latitude: number, longitude: number): Promise<string> {
  //   const apiKey = 'a765ea2de25b4a288eca77445570a49d';
  //   const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;
  //   return fetch(url)
  //     .then((response) => response.json())
  //     .then((data) => data.results[0].components.continent);
  // }

  // private async getStorageApiBySite(sitesId: any): Promise<boolean> {
  //   var storageApiDto: storageApiDto = {
  //     sitesId: sitesId
  //   }
  //   return new Promise<boolean>((resolve, reject) => {
  //     this.controlTowerService.getStorageApiBySite(storageApiDto).subscribe(
  //       {
  //         next: (data: any) => {

  //           let location = localStorage.getItem('location')

  //           data.
  //           console.log("data - location", data, location)

  //           resolve(true);
  //         }, error: (error: HttpErrorResponse) => {
  //           resolve(false);
  //         }
  //       }
  //     )
  //   });
  // }
}
